import { render, staticRenderFns } from "./BoxNumberItem.vue?vue&type=template&id=520e356e&scoped=true&"
import script from "./BoxNumberItem.vue?vue&type=script&lang=js&"
export * from "./BoxNumberItem.vue?vue&type=script&lang=js&"
import style0 from "./BoxNumberItem.vue?vue&type=style&index=0&id=520e356e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e356e",
  null
  
)

export default component.exports